/**
 * Created on 2024/5/14
 */

'use strict';
const CONSTANT = {};

// 默认用户
CONSTANT.DEFAULT_USER_ID = 10000002;

// 货币类型
CONSTANT.CURRENCY = {
  rmb: 10000001,
  dollar: 10000002,
  rouble: 10000003,
};
CONSTANT.CURRENCY_MAP = {
  rmb: 10000001,
  dollar: 10000002,
  rouble: 10000003,
};

// 付款方式
CONSTANT.PAY_WAY = {
  allBefore: 10000001,
  halfHalf: 10000002,
  allAfter: 10000003,
}

// 流向
CONSTANT.DIRECT_CODE = {
  leaveRus: '1001',
  enterRus: '1002',
}

export default CONSTANT;
